import React from "react";
import { useNavigate } from "react-router-dom";
import { CreditCard, UserPlus, Link2, ShieldCheck, Banknote, ArrowLeft } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { Button } from "../components/ui/button";

export default function PaymentsGuide() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const steps = t("stripeGuide.steps"); // array
  const icons = [UserPlus, Link2, ShieldCheck, Banknote];

  return (
    <div className="max-w-2xl mx-auto px-4 py-8" data-testid="payments-guide-page">
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700 mb-4">
        <ArrowLeft className="h-4 w-4" /> {t("common.back")}
      </button>

      <div className="flex items-center gap-3">
        <span className="h-12 w-12 grid place-items-center rounded-2xl bg-[#635bff] text-white shrink-0"><CreditCard className="h-6 w-6" /></span>
        <div>
          <h1 className="font-display font-extrabold text-2xl sm:text-3xl">{t("stripeGuide.title")}</h1>
          <p className="text-sm text-slate-500 mt-1">{t("stripeGuide.subtitle")}</p>
        </div>
      </div>

      <div className="mt-8 space-y-4">
        {(Array.isArray(steps) ? steps : []).map((s, i) => {
          const Icon = icons[i] || ShieldCheck;
          return (
            <div key={i} className="flex items-start gap-4 rounded-2xl border border-slate-200 p-5 bg-white" data-testid={`guide-step-${i + 1}`}>
              <span className="h-9 w-9 grid place-items-center rounded-full bg-teal-50 text-[#008080] font-display font-bold shrink-0">{i + 1}</span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <Icon className="h-4 w-4 text-[#008080]" />
                  <p className="font-semibold text-sm">{s.title}</p>
                </div>
                <p className="text-sm text-slate-500 mt-1">
                  {s.text}
                  {s.link && (
                    <> <a href={s.link} target="_blank" rel="noopener noreferrer" className="text-[#635bff] font-medium hover:underline break-all">{s.link}</a></>
                  )}
                </p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 rounded-2xl bg-emerald-50 border border-emerald-200 p-5 text-emerald-800 text-sm" data-testid="guide-no-fee">
        {t("stripeGuide.noFee")}
      </div>

      <div className="mt-6 flex gap-2">
        <Button data-testid="guide-go-profile" onClick={() => navigate("/profile")} className="bg-[#008080] hover:bg-[#006666]">{t("stripeGuide.goProfile")}</Button>
        <Button data-testid="guide-create-account" variant="outline" onClick={() => window.open("https://dashboard.stripe.com/register", "_blank", "noopener")}>{t("stripeConnect.createFree")}</Button>
      </div>
    </div>
  );
}
